// extracted by mini-css-extract-plugin
export default {"pageContainer":"styles_pageContainer__5XeuF","pageContent":"styles_pageContent__VqZoM","pageDashboardContainer":"styles_pageDashboardContainer__ewaSc"};